import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { rests } from '@core/util/rests';
import { GenericGeoUnit, GeoUnitListCopy } from '@shared/models/generic-geo-unit';
import { GeoUnitType } from '../../models/partners/partner-const-types';
import { CountryCode } from 'libphonenumber-js';
import { tap } from 'rxjs/operators';
import { observableWrapper } from '@core/util/observable-wrapper';

@Injectable({
  providedIn: 'root',
})
export class GeoUnitService {
  private GeoUnitStorage = {
    [GeoUnitType.COUNTRY]: [],
    [GeoUnitType.REGION]: new Map(),
    [GeoUnitType.SETTLEMENT]: new Map(),
  };

  private settlementStorage = new Map();

  constructor(private http: HttpClient) {}

  geoUnitList<T>(type: GeoUnitType, parentId?: number): Observable<GenericGeoUnit<T>[]> {
    if (type === GeoUnitType.COUNTRY) {
      if (this.GeoUnitStorage[type].length > 0) {
        return observableWrapper<GenericGeoUnit<T>[]>(this.GeoUnitStorage[type]);
      }
    } else {
      if (this.GeoUnitStorage[type].has(parentId)) {
        return observableWrapper<GenericGeoUnit<T>[]>(this.GeoUnitStorage[type].get(parentId));
      }
    }

    let params: any = { type };
    if (parentId) {
      params = { ...params, parentId };
    }

    return this.http.get<GenericGeoUnit<T>[]>(rests.geo.unit_list, { params }).pipe(
      tap((data) => {
        if (type === GeoUnitType.COUNTRY) {
          this.GeoUnitStorage[type] = data;
        } else {
          this.GeoUnitStorage[type].set(parentId, data);
        }
      })
    );
  }

  geoUnitListByCountry(countryId = 1): Observable<GeoUnitListCopy[]> {
    if (this.settlementStorage.has(countryId)) {
      return observableWrapper<GeoUnitListCopy[]>(this.settlementStorage.get(countryId));
    }
    const params = {
      countryId: String(countryId),
    };
    return this.http.get<GeoUnitListCopy[]>(rests.geo.list_copy, { params }).pipe(
      tap((data) => {
        this.settlementStorage.set(countryId, data);
      })
    );
  }
}

export interface MappedCountryData {
  id: number;
  name: string;
  code: string;
  mask: string;
  placeholder: string;
  countryCode: CountryCode;
  currencyCode?: string;
}

export interface CountriesHashData {
  byCode: Map<number, MappedCountryData>;
  byCountry: Map<CountryCode, MappedCountryData>;
}
